import { createRoute, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/router/root-route';

/** `/` → redireciona pra `/testes` (única seção hoje; a home do admin é a config
 *  de plataforma). Novas seções mudam este destino. */
export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/testes' });
  },
});
